import styled, { css } from "styled-components";

interface IImersiveLayoutBackgroundBannerContainerProps {
  shouldShowFallbackBackground: boolean;
  fallbackBackground: string;
}

export const ImersiveLayoutBackgroundBannerContainer = styled.div<IImersiveLayoutBackgroundBannerContainerProps>`
  position: relative;

  aspect-ratio: 16/9;

  grid-area: content;

  max-height: 1080px;
  width: 100%;

  ${({ shouldShowFallbackBackground, fallbackBackground }) =>
    shouldShowFallbackBackground &&
    css`
      background-color: ${fallbackBackground};

      img {
        display: none;
      }
    `}

  img {
    object-fit: cover;

    border: none;
  }

  .gradient-background {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, rgb(0 0 0 / 0%), rgb(0 0 0 / 0%)),
      linear-gradient(
        180.65deg,
        rgb(11 10 13 / 0%) -119.39%,
        ${({ theme }) => theme.classwork.imersive.backgroundColor} 55.1%
      );

    transition: 0.3s all;
  }
`;
